import { useId } from 'react'
import ScoopSpinnerGif from '../../../assets/common/Scoop_Loader.gif'
import styles from './AIAvatarThinking.module.scss'

const AIAvatarThinking = ({ className }) => {
    const maskId = useId()

    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <defs>
                {/* Mask to clip the GIF to the robot face shape */}
                <clipPath id={maskId}>
                    <rect x="3" y="5" width="18" height="16" rx="5" />
                </clipPath>
            </defs>

            {/* Antenna */}
            <path d="M12 2V5" className="stroke" strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="2" r="1.5" className={`fill ${styles.antennaPulse}`} />

            {/* Robot Head - background */}
            <rect x="3" y="5" width="18" height="16" rx="5" className="head" strokeWidth="2" />

            {/* Scoop Loader GIF inside the face */}
            <image
                href={ScoopSpinnerGif}
                x="3"
                y="5"
                width="16"
                height="16"
                preserveAspectRatio="xMidYMid slice"
                clipPath={`url(#${maskId})`}
            />

            {/* Ears */}
            <path d="M1 10H3" className="stroke" strokeWidth="2" strokeLinecap="round" />
            <path d="M21 10H23" className="stroke" strokeWidth="2" strokeLinecap="round" />
        </svg>
    )
}

export default AIAvatarThinking
